import { useMutation, useQueryClient } from "@tanstack/vue-query";
import OpportunityStage from "@/services/opportunity/opportunity-stage";
import type { EditOpportunityStage } from "@/dtos/OpportunityStage.dto";

export function useUpdateOpportunityStage() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: EditOpportunityStage) => {
      const result = await OpportunityStage.editOpportunityStage(payload);

      if (result.data.status) {
        return result.data.data;
      }

      throw new Error(result.data.msg || "Failed to update opportunity stage");
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["opportunityStages"] });
    },
  });
}
